import { Station } from '@app/core/types/stations';
import { ListSubheader } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

interface StationsSelectorSectionProps {
  readonly title: MessageDescriptor;
  readonly titleValues?: Record<string, string>;
  readonly stations: readonly Station[];
  readonly isSmall: boolean;
  readonly hasPreviousSection: boolean;
  readonly renderStation: (station: Station, globalIndex: number) => ReactNode;
  readonly startIndex: number;
}

/**
 * Renders a titled section of station list items inside the stations navigator popover.
 */
export function StationsSelectorSection({
  title,
  titleValues,
  stations,
  isSmall,
  hasPreviousSection,
  renderStation,
  startIndex,
}: StationsSelectorSectionProps) {
  if (stations.length === 0) {
    return null;
  }

  return (
    <>
      <ListSubheader
        sx={{
          ...(isSmall ? { lineHeight: 28, typography: 'caption' } : {}),
          ...(hasPreviousSection ? { mt: isSmall ? 1 : 1.5 } : {}),
        }}
      >
        <FormattedMessage {...title} values={titleValues} />
      </ListSubheader>
      {stations.map((station, index) => renderStation(station, startIndex + index))}
    </>
  );
}
